import { Person } from '@fs/zion-person'
import { List, MarginBox } from '@fs/zion-ui'
import React from 'react'
import ChildListItemWrapper from './ChildListItemWrapper'

// TODO make PersonRow support loading state and use that instead of Person component

type Props = {
  count: number
}

export default function ChildrenListSkeleton({ count }: Props): JSX.Element {
  return (
    <List as="ol" data-testid="children-person-list">
      {Array.from({ length: count }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key -- readonly
        <ChildListItemWrapper key={index}>
          <MarginBox marginY="nano">
            <Person loading avatarSize="smaller" />
          </MarginBox>
        </ChildListItemWrapper>
      ))}
    </List>
  )
}
